<template>
    <div>
        <v-progress-linear :color="color" v-model="strength"/>
        <div class="hints-container">
            <span  v-if="hasLength && !hasSpecialChar">Au moins 1 caractère spécial ('!@#$%^&*()-+ ou espace)</span>
            <span v-if="hasLength && !hasLowerCase">Au moins 1 lettre en minuscule</span>
            <span v-if="hasLength && !hasUpperCase">Au moins 1 lettre en majuscule</span>
            <span v-if="hasLength && !hasDigits">Au moins 1 chiffre</span>
        </div>
    </div>
</template>

<script>

	const MIN_LENGTH = 8;

	export default {
		name: "PasswordStrength",
		props: ['password', 'value'],
		data() {
			return {
				color: "",
				strength: 0,
				hasSpecialChar: false,
				hasSpecialCharRegEx: /(?=.*[()'!@#$%^&*\-+ ])/,
				hasLowerCase: false,
				hasLowerCaseRegEx: /(?=.*[a-z])/,
				hasUpperCase: false,
				hasUpperCaseRegEx: /(?=.*[A-Z])/,
				hasDigits: false,
				hasDigitsRegEx: /(?=.*[0-9])/,
				hasLength: false,
			}
		},
		watch: {
			password(newVal) {
				this.hasLowerCase = this.hasLowerCaseRegEx.test(newVal);
				this.hasUpperCase = this.hasUpperCaseRegEx.test(newVal);
				this.hasDigits = this.hasDigitsRegEx.test(newVal);
				this.hasSpecialChar = this.hasSpecialCharRegEx.test(newVal);
				this.hasLength = newVal.length >= MIN_LENGTH;
				this.updateStrength();
			}
		},
		methods: {
			updateStrength() {
				let length = this.password.length;

				let newStrength = 0;
				if (this.hasLowerCase) newStrength++;
				if (this.hasUpperCase) newStrength++;
				if (this.hasDigits) newStrength++;
				if (this.hasSpecialChar) newStrength++;

				newStrength *= .25;
				if (newStrength < 1) {
					let coef = (length / MIN_LENGTH);
					if (coef > 1) coef = 1;
					newStrength *= 75 * coef;
				} else {
					newStrength *= 75 * (length / MIN_LENGTH);
				}

				this.$emit('input', newStrength >= 75);

				this.strength = newStrength > 100 ? 100 : newStrength;

				this.color = this.toColor(newStrength);
				this.$emit('color', this.color);
			},
			toColor(strength) {
				if (strength < 25) return 'red'
				if (strength < 32.5) return 'deep-orange'
				if (strength < 50) return 'orange'
				if (strength < 62.5) return 'amber darken-1'
				if (strength < 75) return 'yellow darken-2'
				else return 'success'
			}
		}
	}
</script>

<style scoped>
    .hints-container {
        display: flex;
        flex-direction: column;
    }

    .hints-container span {
        font-size: smaller;
        color: gray;
    }
</style>
